// South Africa formatting helpers
export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-ZA", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
    timeZone: "Africa/Johannesburg",
  }).replace(",", "");
};

export const fmtDateShort = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-ZA", {
    day: "2-digit", month: "2-digit", year: "numeric",
    timeZone: "Africa/Johannesburg",
  });
};

export const fmtMoney = (cents) => {
  if (cents == null) return "—";
  const rand = cents / 100;
  return "R " + rand.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Rand string ("R 1,500.00" or "1500.5") -> integer cents; empty/invalid -> 0.
export const randToCents = (val) => {
  if (val == null || val === "") return 0;
  const s = String(val).replace(/[^0-9.,-]/g, "").replace(/\s/g, "");
  const normalised = s.replace(/,/g, "");
  const num = parseFloat(normalised);
  if (!isFinite(num)) return 0;
  return Math.round(num * 100);
};

export const centsToRandString = (cents) => {
  if (cents == null || cents === 0) return "";
  return (cents / 100).toFixed(2);
};
